import { compose } from 'lodash/fp'
import { withTranslation } from 'react-i18next'
import withState from './withState'
import Integrations from './Integrations'
import withLoadOnMount from './loadRoomOnMount'

export default compose(
  withTranslation(),
  withState,
  withLoadOnMount,
)(Integrations)
